<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="80px">
    <el-form-item label="用户昵称" prop="nickname">
      <el-input v-model="form.nickname" maxlength="30" />
    </el-form-item>
    <el-form-item label="个人网站" prop="webSite">
      <el-input v-model="form.webSite" />
    </el-form-item>
    <el-form-item label="个人简介" prop="intro">
      <el-input v-model="form.intro" type="textarea" rows="3" />
    </el-form-item>

    <el-form-item>
      <el-button type="primary" size="mini" @click="submit">保存</el-button>
      <el-button type="danger" size="mini" @click="close">关闭</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {updateUserProfile} from "@/api/system/user";

export default {
  props: {
    user: {
      type: Object
    }
  },
  data() {
    return {
      form: {},
      // 表单校验
      rules: {
        nickname: [
          { required: true, message: '用户昵称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    user: {
      handler(user) {
        if (user) {
          this.form = { nickname: user.nickname, webSite: user.webSite, intro: user.intro }
        }
      },
      immediate: true
    }
  },
  methods: {
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          updateUserProfile(this.form).then(response => {
            if (response.flag) {
              this.$modal.msgSuccess('修改成功')
              this.$store.commit('SET_NICK_NAME', this.form.nickname)
              this.user.nickname = this.form.nickname
            } else {
              this.$modal.msgError(response.msg)
            }
          })
        }
      })
    },
    close() {
      this.$tab.closePage()
    }
  }
}
</script>
